<script lang="ts">
  import { loginWithMicrosoft, sessionExpired$, user } from '../firebase/auth';
  import Modal from './Modal.svelte';
  const open = $derived($sessionExpired$ && $user != null);
  const close = () => sessionExpired$.next(false);
</script>

<Modal {open} onClose={close}>
  <h2 class="modal-title">Logg inn på nytt</h2>
  <p class="modal-message">
    Sesjonen er utløpt. Du må logge inn på nytt for å fortsette.
  </p>
  <div class="modal-actions">
    <button class="btn secondary" onclick={close}>Avbryt</button>
    <button
      class="btn primary"
      onclick={() => {
        loginWithMicrosoft()
          .then(close)
          .catch(() => {
            // Keep modal open if login promise rejects
          });
      }}
    >
      Logg inn
    </button>
  </div>
</Modal>

<style>
  .modal-title {
    font-size: 1rem;
    font-weight: 700;
    color: var(--text);
    margin: 0 0 0.5rem;
    padding-inline-end: 2rem;
  }

  .modal-message {
    font-size: 0.875rem;
    color: var(--text-muted);
    margin: 0 0 1.5rem;
  }

  .modal-actions {
    display: flex;
    gap: 0.5rem;
    justify-content: flex-end;
    width: 100%;
  }
</style>
